import { Injectable } from '@angular/core';
import { footerTemplatesStyle } from './footer-template-styles';

@Injectable({
  providedIn: 'root'
})
export class FooterTemplateService {

  constructor() { }

  /**
   * Get all footer templates from local config
   */
  getFooterTemplates() {
    return footerTemplatesStyle
  }

  /**
   * Get a specific footer template by ID from local config
   */
  getFooterTemplateById(id: string) {
    return (footerTemplatesStyle as any)[id] || null
  }

  /**
   * Get list of available template IDs
   */
  getAvailableTemplateIds(): string[] {
    return Object.keys(footerTemplatesStyle)
  }
}
